import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import * as React from "react";
import mergeRefs from "react-merge-refs";
import { throttleTime } from "rxjs";
import { getEditorDataProps } from "../dom-utils";
import { useInput } from "../input";
import { useObserved } from "../react-utils";
import Content from "./content";
export const EditorContext = React.createContext(null);
class Recovery extends React.Component {
    constructor(props) {
        super(props);
        this.state = { timestamp: Date.now() };
    }
    static getDerivedStateFromError(_error) {
        // Update state so the next render will show the fallback UI.
        return { timestamp: Date.now() };
    }
    recover() {
        this.setState({ timestamp: Date.now() });
    }
    componentDidCatch(error) {
        console.error(error);
    }
    render() {
        return this.props.children(this.state.timestamp);
    }
}
const Editor = React.forwardRef(function Editor({ model: model0, className, emptyClassName, onFocus, onBlur, inline = false, ...htmlProps }, ref) {
    const editorElementRef = React.useRef(null);
    const model = model0;
    const content = useObserved(() => model.content, [model], () => model.onContentChange, [model]);
    const readonly = useObserved(() => model.readonly, [model], () => model.onReadonlyChange, [model]);
    const modelMarkers = useObserved(() => model.markers.slice(0), [model], () => model.onMarkersChange.pipe(throttleTime(0, undefined, {
        leading: false,
        trailing: true,
    })), [model]);
    const markers = modelMarkers.filter((it) => it.endOffset - it.offset > 0);
    const composing = useObserved(() => model.isComposing, [model], () => model.onComposingChange, [model]);
    const recoveryRef = React.useRef(null);
    React.useEffect(() => {
        model.setRecoverHandler(() => {
            var _a;
            (_a = recoveryRef.current) === null || _a === void 0 ? void 0 : _a.recover();
        });
        model.setEditorElement(editorElementRef.current);
        return () => {
            model.setEditorElement(null);
        };
    }, [model]);
    useInput(model);
    React.useLayoutEffect(() => {
        if (model.isContentRendered) {
            model.emitContentRendered();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [content]);
    return (_jsx(EditorContext.Provider, Object.assign({ value: model }, { children: _jsx("div", Object.assign({ ref: mergeRefs([editorElementRef, ref]), contentEditable: !readonly, suppressContentEditableWarning: true, className: cx(className, content.length === 0 && !composing ? emptyClassName : undefined), onFocus: (event) => {
                onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                model.emitActiveChange();
            }, onBlur: (event) => {
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                model.emitActiveChange();
            } }, getEditorDataProps(model, content), htmlProps, { children: _jsx(Recovery, Object.assign({ ref: recoveryRef }, { children: (timestamp) => (_jsxs(React.Fragment, { children: [_jsx(Content, Object.assign({}, content, { baseOffset: 0, markers: markers }), void 0), !inline && _jsx("br", { contentEditable: "false" }, void 0)] }, timestamp)) }), void 0) }), void 0) }), void 0));
});
export default Editor;
